<template>
  <b-card>
    <b-card-title class="mb-1 d-flex align-items-center">
      <span style="margin-left: 5px">Aktivitas Terbaru</span>
    </b-card-title>
    <loader v-if="loading" />
    <div v-else-if="activities.length > 0" class="mt-2" style="max-height: 400px; overflow-y: auto;">
      <app-timeline>
        <app-timeline-item 
          v-for="(act, idx) in activities" 
          :key="idx" 
          :variant="getPlatformVariant(act.platform)"
        >
          <div class="d-flex justify-content-between align-items-sm-center mb-50">
            <div class="d-flex align-items-center">
              <b-avatar size="sm" :text="(act.operator || 'U').charAt(0).toUpperCase()" variant="light-primary" class="mr-1" />
              <h6 class="mb-0">
                <strong>{{ act.operator }}</strong> mengirim <strong>{{ act.post_count }}</strong> postingan ke <strong>{{ formatSyncedTo(act.synced_to) }}</strong>
              </h6>
            </div>
            <small class="text-muted d-none d-sm-block">{{ timeAgo(act.synced_at) }}</small>
          </div>
          <div style="margin-left: 38px">
            <small class="text-muted d-block d-sm-none mb-50">{{ timeAgo(act.synced_at) }}</small>
            <p class="mb-0 text-muted">
              dari <a :href="act.url" target="_blank" class="font-weight-bold">{{ act.fanpage }}</a> 
              <b-badge :variant="getPlatformVariant(act.platform)" pill class="ml-50">
                <feather-icon :icon="getPlatformIcon(act.platform)" size="12" class="mr-25" />
                {{ act.platform }}
              </b-badge>
            </p>
          </div>
        </app-timeline-item>
      </app-timeline>
    </div>
    <div v-else class="text-center py-5">
      <p class="text-muted">Tidak ada aktivitas terbaru.</p>
    </div>
  </b-card>
</template>
<script>
import loader from "@/views/components/loader.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { BAvatar, BBadge } from "bootstrap-vue";
import moment from "moment";
import "moment/locale/id"; // Import Indonesian locale

export default {
  name: "SmdRecentActivityFeed",
  components: { 
    loader,
    AppTimeline,
    AppTimelineItem,
    BAvatar,
    BBadge
  },
  props: {
    loading: { type: Boolean, default: false },
    activities: { type: Array, default: () => [] },
  },
  methods: {
    timeAgo(dateStr) {
      if (!dateStr) return "-";
      return moment(dateStr).locale("id").fromNow();
    },
    formatSyncedTo(syncedTo) {
      if (!syncedTo) return "Sistem";
      const s = syncedTo.toLowerCase();
      if (s === "both") return "SMA & Datalake";
      if (s === "sma") return "SMA";
      if (s === "datalake") return "Datalake";
      return syncedTo;
    },
    getPlatformVariant(platform) {
      const p = (platform || "").toLowerCase();
      if (p === "facebook") return "primary";
      if (p === "instagram") return "danger";
      if (p === "tiktok") return "dark";
      return "info";
    },
    getPlatformIcon(platform) {
      const p = (platform || "").toLowerCase();
      if (p === "facebook") return "FacebookIcon";
      if (p === "instagram") return "InstagramIcon";
      if (p === "tiktok") return "VideoIcon";
      return "LinkIcon";
    }
  }
};
</script>
